import ColorScaleService from '@/services/ColorScale.service';

export default class Tone {
    color: string;
    freq: any;
  
    constructor(colorHue: number, luminance: number, freq: number){
      this.color = ColorScaleService.hueToHEX(colorHue, luminance);
      this.freq = freq;
    }
}